import React from 'react';
import {
    DepuisQuandQuestionSlideWrapper,
    QuestionContent,
    QuestionText,
    ButtonsWrapper,
} from 'pages/questionnaire/slides/depuisquand/DepuisQuandQuestionSlide.styled';
import { Questionnaire } from 'types/app';
import { PageTitle } from 'layout/page/Page.layout.styled';
import { getLocaleValue } from 'helpers/utils';
import { useTranslation } from 'react-i18next';
import IpsativeResponses from 'components/questionnaire/IpsativeResponses';
import Button from 'components/common/button/Button';

export interface DepuisQuandQuestionSlideProps {
    question?: Questionnaire.IIpsativeQuestion;
    gotoPrevious?: () => void;
    gotoNext?: () => void;
    onAnswer?: (questionWithResponse: Questionnaire.IIpsativeQuestion) => void;
    questionIndex?: number;
    totalQuestions?: number;
}

const DepuisQuandQuestionSlide: React.FC<DepuisQuandQuestionSlideProps> = ({
    question,
    gotoPrevious,
    gotoNext,
    onAnswer,
    questionIndex = 0,
    totalQuestions = 0,
}) => {
    const { i18n, t } = useTranslation('translation');

    const getTitle = () => {
        const remaining = totalQuestions - questionIndex;
        if (remaining === 1) return t('questionnaire.depuisquand.one-last-question');
        if (remaining === 2) return t('questionnaire.depuisquand.two-questions-left');
        return t('questionnaire.depuisquand.title');
    };

    const handleAnswerSelect = (answer: Questionnaire.IIpsativeAnswer) => {
        if (question && onAnswer) {
            const updatedQuestion: Questionnaire.IIpsativeQuestion = {
                ...question,
                selectedAnswerId: answer.id,
            };
            onAnswer(updatedQuestion);
        }
    };

    if (!question) {
        return null;
    }

    return (
        <DepuisQuandQuestionSlideWrapper>
            <PageTitle style={{
                margin: '0 0 10px 0',
                fontSize: '16px',
                // display: 'none'
            }}>{getTitle()}</PageTitle>
            <QuestionContent>
                {/* No groups for Depuis Quand questionnaire */}
                <QuestionText>{getLocaleValue(question.label, i18n.language)}</QuestionText>
                <IpsativeResponses
                    answers={question.answers}
                    selectedAnswerId={question.selectedAnswerId}
                    onSelect={handleAnswerSelect}
                />
                <ButtonsWrapper>
                    <Button
                        onClick={() => {
                            gotoPrevious && gotoPrevious();
                        }}
                        fill="outline"
                        className={!gotoPrevious ? 'btn-navigate-disabled' : 'btn-navigate'}
                        disabled={!gotoPrevious}
                    >
                        {t('common.previous')}
                    </Button>
                    <Button
                        onClick={() => {
                            gotoNext && gotoNext();
                        }}
                        fill="outline"
                        className={!gotoNext ? 'btn-navigate-disabled' : 'btn-navigate'}
                        disabled={!gotoNext}
                    >
                        {t('common.next')}
                    </Button>
                </ButtonsWrapper>
            </QuestionContent>
        </DepuisQuandQuestionSlideWrapper>
    );
};

export default DepuisQuandQuestionSlide;
